import React from "react";
import { transformComma } from "../../../utils/validator/comma";

const PensionSummaryTable = ({ data }) => {
  if (!data) {
    return <p>데이터가 없습니다.</p>;
  }

  const getValue = (key) => transformComma(data[key] || "0");

  return (
    <>
      <h4 className="si4n-title">{data.fmNm}</h4>

      <table className="si4n-table">
        <thead>
          <tr>
            <th>(예정) 당월분 산출내역</th>
            <th>구분</th>
            <th>(최종) 당월분 결정내역</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{getValue("sPrsnCnt")} 명</td>
            <td>당월분 산출인원</td>
            <td>{getValue("ePrsnCnt")} 명</td>
          </tr>
          <tr>
            <td>{getValue("sAmt")} 원</td>
            <td>① 당월분 연금보험료</td>
            <td>{getValue("eAmt")} 원</td>
          </tr>
          <tr>
            <td>{getValue("sIncrease")} 원</td>
            <td>② 소급분 연금보험료 (+)</td>
            <td>{getValue("eIncrease")} 원</td>
          </tr>
          <tr className="row-highlight">
            <td colSpan="3">
              <strong>소급분 구분</strong>
            </td>
          </tr>
          <tr>
            <td>{getValue("sRcpIns")} 원</td>
            <td>③ 수납보험료</td>
            <td>{getValue("eRcpIns")} 원</td>
          </tr>
          <tr>
            <td>{getValue("sSplInterest")} 원</td>
            <td>④ 충당내역(이자)</td>
            <td>{getValue("eSplInterest")} 원</td>
          </tr>
          <tr>
            <td>{getValue("sEmlReduc")} 원</td>
            <td>⑤ 이메일 감액금액</td>
            <td>{getValue("eEmlReduc")} 원</td>
          </tr>
          <tr>
            <td>{getValue("sNtsrSbsamDdctAmt")} 원</td>
            <td>⑥ 국고지원공제금액 계</td>
            <td>{getValue("eNtsrSbsamDdctAmt")} 원</td>
          </tr>
          <tr>
            <td>{getValue("sBlc")} 원</td>
            <td>⑦ 당월분 차감잔액</td>
            <td>{getValue("eBlc")} 원</td>
          </tr>
          <tr className="final-row">
            <td>{getValue("sPay")} 원</td>
            <td>
              <strong>최종 징수 결정액</strong>
            </td>
            <td>{getValue("ePay")} 원</td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default PensionSummaryTable;
